import { useMutation } from 'react-query';
import createRoomAttachments from '../requests/createRoomAttachments';

const useAddRoomAttachmentsMutation = (options) =>
  useMutation(
    ({ roomId, files }) => createRoomAttachments(roomId, files),
    options
  );

export default useAddRoomAttachmentsMutation;
